<template>
  <div style="height: 100%; position:relative;">
    <div class="bg-modal w-maxC" style="position: absolute; top: 0;right: 0; cursor: auto;" @click.stop>
      <div class="table columns" style="gap: 4rem;">
        <!-- Col 1 -->
        <div class="1 col thin-gap">
          <!-- Personne -->
          <div class="row-top">
            <div class="pad-s">
              <svg-item icon="person" styles="main-m size-l"/>
            </div>
            <div>
              <button-group v-if="!isAdult" styles="pad-s" class="w-full" @click="startWithNewText(t('patient.addMonitored.childFollowUp'))">
                <text-item :txt="t('patient.addMonitored.childFollowUp')"/>
              </button-group>
              <button-group v-if="isAdult" styles="pad-s" class="w-full" @click="startWithNewText(t('patient.addMonitored.adultFollowUp'))">
                <text-item :txt="t('patient.addMonitored.adultFollowUp')"/>
              </button-group>
            </div>
          </div>
        </div>
        <!-- Col 2 -->
        <div class="col2 col" style="gap: 1.5rem;">
          <!-- Grossesse -->
          <div v-if="isFemale && patientAge > 15 && patientAge < 45" class="row-top">
            <div class="pad-s">
              <svg-item icon="pregnancy" styles="main-m size-l"/>
            </div>
            <div>
              <button-group styles="pad-s" class="w-full" @click="startWithNewText(t('patient.addMonitored.pregnancyFollowUp'))">
                <text-item :txt="t('patient.addMonitored.pregnancyFollowUp')"/>
              </button-group>
            </div>
          </div>
          <!-- Voyage -->
          <div class="row-top">
            <div class="pad-s">
              <svg-item icon="infectious" styles="main-m size-l"/>
            </div>
            <div>
              <button-group styles="pad-s" class="w-full" @click="startWithNewText(t('patient.addMonitored.travelFollowUp'))">
                <text-item :txt="t('patient.addMonitored.travelFollowUp')"/>
              </button-group>
            </div>
          </div>
        </div>
        <!-- Col 3 / Favorites-->
        <div class="col3 col thin-gap">
          <div class="row-top">
            <!-- Favorites Icon Button -->
            <dropdownBox v-model="dropd" openOn="RbMonitored">
              <button-group class="pad-s">
                <svg-item icon="star" styles="main-h size-l" class="txt-primary"/>
              </button-group>
              <template #dropd>
                <editAppUserPreferences :title="t('patient.addMonitored.favorites')" referenceTextType="RbMonitored" dtoKey="rbMonitored"/>
              </template>
            </dropdownBox>
            <!-- Button for each favorite -->
            <div>
              <template v-for="(suggestion, index) in appUserStore.currentAppUserData?.preferences?.rbMonitored.split('\n')" :key="index">
                <template v-if="suggestion">
                  <button-group styles="pad-s" class="leftRight" @click="startWithNewText(suggestion)">
                    <text-item :txt="suggestion"/>
                  </button-group>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- Separator -->
      <div class="mtop-10"/>
      <!-- InputBox -->
      <inputComboBox2 ref="focus" class="mtop-15" v-model="contentText" style="width: 100%;" :hasDropd=false @keyup.enter="createFCT()">
        <template #post>
          <div class="line-v"/>
          <buttonGroup theme="inline" @click="createFCT()">
            <svg-item icon="check" styles="size-l"/>
          </buttonGroup>
        </template>
      </inputComboBox2>
    </div>
  </div>
</template>

<script setup>
import editAppUserPreferences from '@/views/patientMain/editAppUserPreferences.vue'
import { ref, computed, onMounted } from 'vue'
import { apiDate } from "@/api/apicommon"
import patientapi from "@/api/patientapi"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from "vue-i18n";

const props = defineProps({
  monitoredAdded: {
    type: Function,
    required: false
  }
});

const { t } = useI18n();
const appUserStore = useAppUserStore()
const currentEntryStore = useCurrentEntryStore()

const focus = ref(null)
const dropd = ref(null)
const contentText = ref("")

const isFemale = computed(() => {
  return currentEntryStore.currentPatient.biologicalSex === 'Female'
});

const isAdult = computed(() => {
  return patientAge.value > 18
})

const patientAge = computed(() => {
  const entryDate = apiDate(currentEntryStore.currentEntryDate)
  const birthDate = apiDate(currentEntryStore.currentPatient.birthDate)
  const timeDifference = entryDate - birthDate
  const years = timeDifference / (365 * 24 * 60 * 60 * 1000)
  return years
}) 

function startWithNewText(newText) {
  contentText.value = newText ? newText + ' ' : ''
  focus.value.innerRef.focus()
}

async function createFCT() {
  const entryId = currentEntryStore.currentEntryId;
  const newText = contentText.value.trim();
  if (!newText) return;
  contentText.value = "";
  await patientapi.addMonitored(newText,entryId);

  if (props.monitoredAdded) {
    props.monitoredAdded();
  }

  currentEntryStore.reloadAfterHistoryChange();
}

onMounted(() => {
  focus.value.innerRef.focus()
})

</script>


<style scoped>
.columns {
  grid-template-columns:
    [col1] max-content
    [col2] max-content
    [col3] max-content
}
.thin-gap{
  gap: 1.5rem;
}
</style>